// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1Kppg","filesListContainer":"PosDisputesFiles_filesListContainer__30QI0","filesButton":"PosDisputesFiles_filesButton__3bKLu"};